/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    import IReportingHierarchyBranch = Meevo.Model.IReportingHierarchyBranch;

    export class ReportingHierarchyBranchPickerController implements angular.IComponentController {

        static $inject = ['meevo.components.modal.ModalService', 'meevo.components.common.DataService', 'meevo.AppSettings'];

        hierarchyId: string;

        tree: IReportingHierarchyBranch[];
        nodesById: {
            [key: string]: IReportingHierarchyBranch
        };

        selected: string;
        selection: any[] = [];
        onChange: Function;

        chooseAllOption: boolean;

        hasChanges: boolean;
        onChangeConfirm: Function;

        layout: string;

        fetching: boolean = false;

        constructor(
            private modalService: Meevo.Components.Modal.IModalService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings
        ) {

        }

        $onInit() {
            if (Model.Guard.canBeId(this.hierarchyId)) {
                this.fetchTree(this.hierarchyId)
                    .then(() => this.init());
            } else {
                if (!angular.isDefined(this.tree) || !angular.isDefined(this.nodesById)) {
                    console.warn('Either hierarchyId or tree/nodesById is required');
                } else {
                    this.init();
                }
            }

            if (!angular.isDefined(this.layout)) {
                this.layout = 'column';
            }

            if (angular.isUndefined(this.chooseAllOption)) {
                this.chooseAllOption = false;
            }
        }

        $onChanges(changes) {

            const {hierarchyId, selected, tree} = changes;

            if (angular.isDefined(hierarchyId) && !hierarchyId.isFirstChange() && Model.Guard.canBeId(this.hierarchyId)) {
                this.fetchTree(this.hierarchyId)
                    .then(() => {
                        this.buildChain(this.tree[0].branch_TId);
                    })
            }
            if (angular.isDefined(selected) && !selected.isFirstChange()) {
                this.buildChain(this.selected);
            }

            if (angular.isDefined(tree) && !tree.isFirstChange()) {
                this.buildChain(this.selected);
            }
        }

        fetchTree(id) {
            this.fetching = true;
            return this.dataService.getItem(`${this.appSettings.API_ENDPOINTS.reportingHierarchy}Tree/${id}`)
                .then((hiearchy: any) => {
                    const nodes: any[] = hiearchy.branches;

                    this.tree = nodes.map((node): IReportingHierarchyBranch => {
                        node.nodes = nodes.filter(n => n.parentBranch_TId === node.branch_TId);
                        return node;
                    }).filter(node => {
                        return !angular.isDefined(node.parentBranch_TId) || node.parentBranch_TId === null
                    });

                    this.nodesById = nodes.reduce((lookup, node: IReportingHierarchyBranch) => (lookup[node.branch_TId] = node, lookup), {});                    
                })
                .finally(() => {
                    this.fetching = false;
                })
        }

        init() {
            if (!angular.isDefined(this.selected) || this.selected === null) {
                this.selected = this.tree[0].branch_TId;
            }
            this.buildChain(this.selected);
        }

        changeHandler(val) {
            if (angular.isDefined(this.hasChanges)) {
                if (this.hasChanges) {
                    // Set custom option for change name buttons
                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: "app/components/modal/modal.template.html",
                        controller: "meevo.components.modal.ModalController",
                        controllerAs: "vm",
                        bindToController: true,
                        skipHide: false,
                        locals: {
                            message: "You have not saved your changes. If you click OK your changes for assigning locations will be lost.",
                            processNegativeConfirm: false,
                            modalClass: "modal-confirm",
                            headerContentKey: "HEADER_CONFIRM",
                            okButtonContentKey: "LABEL_OK",
                            cancelButtonContentKey: "LABEL_CANCEL",
                            showOkButton: true,
                            showCancelButton: true,
                        }
                    };

                    this.modalService.showCustom(options)
                        .then(res => {
                            this.buildChain(val);
                            if (angular.isDefined(this.onChangeConfirm) && angular.isFunction(this.onChangeConfirm)) {
                                this.onChangeConfirm();
                            }
                        })
                        .catch(res => {
                            this.buildChain(this.selection[this.selection.length - 1]);
                        });

                    return;
                };
            }

            this.buildChain(val);

        }

        buildChain(id) {
            var node = this.nodesById[id] as IReportingHierarchyBranch;

            if (!angular.isDefined(node)) {
                var index = this.selection.length - 1;
                var lastNode = this.nodesById[this.selection[index]];
                while (!angular.isDefined(lastNode)) {
                    lastNode = this.nodesById[this.selection[--index]];
                }
                node = lastNode;
            }

            const chain = [node.branch_TId];

            let {parentBranch_TId: parentId = null} = node;
            while (parentId !== null) {
                chain.unshift(parentId);
                parentId = this.nodesById[parentId].parentBranch_TId;
                if (!angular.isDefined(parentId)) parentId = null;
            }
            chain.unshift(parentId);
            
            let children = node.nodes;
            while (children.length === 1) {
                node = children[0];
                chain.push(node.branch_TId);
                children = node.nodes;
            }
            if (children.length > 1) {
                chain.push(node.branch_TId);
            }
                
            this.selected = chain[chain.length - 1];
            this.selection = chain;
            if (angular.isDefined(this.onChange)) {
                this.onChange({ $event: this.selected });
            }
        }

    }

}